var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionmark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15,
    cy: 14.0625,
    rx: 15,
    ry: 14.0625,
    fill: "#C53EAE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.232 23.8125V20.9325H16.112V23.8125H13.232ZM11.192 11.8365H8.624C8.624 8.1645 11.192 5.9325 15.272 5.9325C18.92 5.9325 21.32 8.0685 21.32 11.1885C21.32 13.1805 20.288 14.8125 18.536 15.8445C16.544 17.0205 16.112 17.6445 16.112 19.2285H13.232C13.232 17.1405 14.288 16.0125 15.824 15.0525C17.624 13.9245 18.752 12.8925 18.752 11.2605C18.752 9.4125 17.408 8.0925 15.032 8.0925C12.632 8.0925 11.192 9.4365 11.192 11.8365Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionmark);
export default __webpack_public_path__ + "static/media/questionmark.72dd52b6812143a72a9b1ce743d0b6c0.svg";
export { ForwardRef as ReactComponent };